import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { KeyboardDatePicker } from "@material-ui/pickers";
import TBLRelatorio from "../../../components/TBLRelatorio";
import { GetEntregadoresEmpresaOuData } from "../../../providers/EntregadorProvider";
import Select from "react-select";
import PDFDetalhesEntrega from "../../../pdfs/PDFDetalhesEntregas";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { getUser } from "../../../services/Auth";

export default class RelatorioEntrega extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInicio: null,
      dataFim: null,
      data: [],
      pedidosEntregadorSelecionados: [],
      pages: 1,
      page: 1,
      loading: false,
      limit: 10,
      dataPedido: null,
      entregadores: [],
      entregadorSelecionado: [],
      totalFaturado: 0,
      estabelecimento: null,
      relatorioDisponivel: false,
      taxa_operacao: 0,
      empresa: "",
      filtro: "",
      modalCarregando: false,
    };
  }

  async componentDidMount() {
    const user = await getUser();
    if (user) {
      this.setState({ estabelecimento: user.estabelecimento });
    }
  }

  getEntregadoresEmpresaEOuData = async () => {
    this.setState({ loading: true });
    let entregadores = [];
    let totalFaturado = 0;
    const { estabelecimento, empresa, dataInicio, dataFim } = this.state;
    const data = {
      empresa: empresa,
      data_inicio: dataInicio ? new Date(dataInicio).toISOString() : "",
      data_fim: dataFim ? new Date(dataFim).toISOString() : "",
    };
    const response = await GetEntregadoresEmpresaOuData(estabelecimento._id, data);

    if (response) {
      response.forEach((pedido) => {
        totalFaturado += pedido.detalhes_pagamento.frete;
        if (!entregadores.some((e) => e.value === pedido.entregador._id)) {
          entregadores.push({
            label: pedido.entregador.nome,
            value: pedido.entregador._id,
          });
        }
      });
    }
    this.setState({
      entregadores,
      filtro: empresa,
      entregadorSelecionado: [...entregadores],
      data: response,
      pedidosEntregadorSelecionados: response,
      loading: false,
      totalFaturado: parseFloat(totalFaturado).toFixed(2).replace(".", ","),
      relatorioDisponivel: true,
    });
  };

  selecionarTodosEntregadores = () => {
    this.setState({ loading: true });
    const { entregadores } = this.state;
    this.setState({
      entregadorSelecionado: [...entregadores],
      loading: false,
    });
  };

  calcularPeriodo = () => {
    const { entregadorSelecionado, data } = this.state;
    this.setState({ loading: true });
    let totalFaturado = 0;
    let newPedidos = [];
    if (data.length) {
      data.forEach((pedido) => {
        entregadorSelecionado.filter((entregador) => {
          if (pedido.entregador._id === entregador.value) {
            totalFaturado += pedido.detalhes_pagamento.frete;
            newPedidos = [...newPedidos, pedido];
          }
        });
      });
    }

    this.setState({
      pedidosEntregadorSelecionados: newPedidos,
      relatorioDisponivel: true,
      totalFaturado: parseFloat(totalFaturado).toFixed(2).replace(".", ","),
      loading: false,
    });
  };

  limparPeriodo = async () => {
    this.setState({
      loading: true,
      dataInicio: null,
      dataFim: null,
      entregadorSelecionado: [],
      totalFaturado: 0,
      relatorioDisponivel: false,
      empresa: "",
      data: [],
    });
    this.setState({ loading: false });
  };

  render() {
    const {
      dataInicio,
      dataFim,
      relatorioDisponivel,
      empresa,
      entregadorSelecionado,
      data,
    } = this.state;
    return (
      <div>
        <Row>
          <Col md={6}>
            <br></br>
            <Row>
              <Col>
                <p style={{ marginBottom: 0, fontWeight: "bold" }}>Defina um período: </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-end",
                    }}
                  >
                    <p style={{ marginRight: 30 }}>De</p>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      margin="normal"
                      label="Data de início"
                      value={dataInicio}
                      maxDate={new Date()}
                      onChange={(d) => this.setState({ dataInicio: d })}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-end",
                    }}
                  >
                    <p style={{ marginRight: 30 }}>Até</p>
                    <KeyboardDatePicker
                      disableToolbar
                      disabled={!this.state.dataInicio}
                      variant="inline"
                      margin="normal"
                      label="Data final"
                      minDate={this.state.dataInicio}
                      maxDate={new Date()}
                      value={dataFim}
                      onChange={(d) => this.setState({ dataFim: d })}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 20,
                    marginTop: 20,
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label style={{ fontWeight: "bold" }}>Empresa</label>
                    <input
                      type="text"
                      placeholder="Digite aqui o nome da empresa"
                      style={{
                        borderTop: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        borderBottomWidth: 1,
                        borderColor: "#701b8c",
                        width: "100%",
                        padding: 5,
                      }}
                      value={empresa}
                      onChange={(text) => {
                        this.setState({ empresa: text.target.value });
                      }}
                    />
                  </div>
                  <Button
                    disabled={(dataInicio && dataFim) || empresa ? false : true}
                    style={{ height: 35, alignSelf: "flex-end" }}
                    onClick={() => {
                      this.getEntregadoresEmpresaEOuData();
                    }}
                  >
                    Filtrar
                  </Button>
                </div>
                <div
                  style={{
                    width: "100%",
                    justifyContent: "space-between",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        display: "inline-flex",
                        alignItems: "center",
                        marginBottom: 10,
                      }}
                    >
                      <p style={{ fontWeight: "bold", marginTop: 15 }}>
                        Selecione o(s) entregador(es):{" "}
                      </p>
                      <Button
                        disabled={entregadorSelecionado.length ? false : true}
                        onClick={() => {
                          this.selecionarTodosEntregadores();
                        }}
                        style={{ height: 35, marginLeft: 10 }}
                      >
                        Selecionar Todos
                      </Button>
                    </div>
                    <Select
                      value={this.state.entregadorSelecionado}
                      options={this.state.entregadores}
                      onChange={(e) => {
                        this.setState({ entregadorSelecionado: e });
                      }}
                      isMulti={true}
                      isClearable={true}
                      placeholder="Selecione o(s) entregador(es)"
                    ></Select>
                  </div>
                </div>
              </Col>
            </Row>
            <br></br>
          </Col>
          <Col style={{ marginTop: 30, marginLeft: "5%" }}>
            <Row>
              <Col>
                <p>
                  <b>Total de entregas:</b>{" "}
                  <p style={{ color: "#701b8c" }}>
                    {this.state.pedidosEntregadorSelecionados.length} entregas
                  </p>
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  <b>Total faturado:</b>{" "}
                  <p style={{ color: "#701b8c" }}>R$ {this.state.totalFaturado}</p>
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                {relatorioDisponivel ? (
                  <PDFDownloadLink
                    document={
                      <PDFDetalhesEntrega
                        data={this.state.pedidosEntregadorSelecionados}
                        estabelecimento={this.state.estabelecimento}
                        dataInicio={this.state.dataInicio}
                        dataFim={this.state.dataFim}
                        entregador={this.state.entregadorSelecionado}
                        totalFaturado={this.state.totalFaturado}
                      />
                    }
                    fileName={`relatorio-entrega-${new Date().toLocaleString()}.pdf`}
                    style={{
                      textDecoration: "none",
                      padding: "10px",
                      color: "white",
                      backgroundColor: "#701B8C",
                      border: "1px solid white",
                      borderRadius: 4,
                    }}
                  >
                    Emitir Relatório
                  </PDFDownloadLink>
                ) : null}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <div
              style={{
                marginRight: "12%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                marginTop: 17,
              }}
            >
              <div>
                <Button
                  disabled={entregadorSelecionado.length || data.length ? false : true}
                  variant="danger"
                  style={{ height: 35, marginRight: 20 }}
                  onClick={() => this.limparPeriodo()}
                >
                  Limpar
                </Button>
                <Button
                  disabled={entregadorSelecionado.length ? false : true}
                  style={{ height: 35 }}
                  onClick={() => {
                    this.calcularPeriodo();
                  }}
                >
                  Aplicar
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <TBLRelatorio
          data={this.state.pedidosEntregadorSelecionados}
          numRows={10}
          loading={this.state.loading}
        />
        {/* <ModalCarregando
                    loading={this.state.loading}
                /> */}
      </div>
    );
  }
}
